module.exports = __webpack_public_path__ + "img/no_address.dedf4696.svg";